import { useAutoSaveForm } from '../../../components/forms/useAutoSaveForm'
import FormHeader from '../../../components/forms/FormHeader'
import { api } from '../../../lib/api'
import Input from '../../../components/ui/Input'

interface State {
  title: string
  target_date: string // ISO
  show: boolean
}

interface Props {
  overlayId: string
  initial: Record<string, unknown>
}

function toLocalInputValue(iso: string): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export default function CountdownForm({ overlayId, initial }: Props) {
  const form = useAutoSaveForm<State>({
    initial: {
      title: (initial.title as string) || 'BAŞLAMASINA',
      target_date: (initial.target_date as string) || '',
      show: initial.show !== false,
    },
    onSave: async (s) => {
      await api(`/api/overlays/${overlayId}/state`, {
        method: 'PATCH',
        body: JSON.stringify(s),
      })
    },
  })

  return (
    <div className="space-y-5">
      <FormHeader
        title="Geri Sayım"
        subtitle="Yayın başlama / event geri sayımı"
        status={form.status}
        savedAt={form.savedAt}
        error={form.error}
        onUndo={form.canUndo ? form.undo : undefined}
      />

      <div className="space-y-3">
        <div>
          <label className="block text-xs font-medium text-[var(--color-text-muted)] mb-1.5">Başlık</label>
          <Input value={form.draft.title} onChange={(e) => form.patch({ title: e.target.value })} />
        </div>
        <div>
          <label className="block text-xs font-medium text-[var(--color-text-muted)] mb-1.5">Hedef tarih</label>
          <Input
            type="datetime-local"
            value={toLocalInputValue(form.draft.target_date)}
            onChange={(e) =>
              form.patch({
                target_date: e.target.value ? new Date(e.target.value).toISOString() : '',
              })
            }
          />
        </div>
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="checkbox"
            checked={form.draft.show}
            onChange={(e) => form.patch({ show: e.target.checked })}
            className="accent-[var(--color-accent)]"
          />
          Geri sayımı göster
        </label>
      </div>
    </div>
  )
}
